import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, EMPTY, Observable, switchMap, tap } from 'rxjs';
import { GroupService } from './group.service';
import { PracticeSettingsStore } from './practice-settings-store.service';

@Injectable({
  providedIn: 'root'
})
export class AppointmentTypeService {
  private apiUrl = 'api';
  private appointmentTypesSubject = new BehaviorSubject<any>(null);
  appointmentTypes$ = this.appointmentTypesSubject.asObservable();

  groupId?: string;

  constructor(
    private http: HttpClient,
    private groupService: GroupService,
    private settingsStore?: PracticeSettingsStore,
  ) {
    this.groupService.selectedGroup$.pipe(
      switchMap(selectedGroup => {
        if (selectedGroup) {
          this.groupId = selectedGroup.id;
          return this.getAppointmentTypesByGroup(selectedGroup.id, true);
        }
        return EMPTY;
      })
    ).subscribe();
  }

  /** `fromKeptCopy`: on a practice switch, the device's kept copy while it is current (PracticeSettingsStore). */
  getAppointmentTypesByGroup(groupId: string, fromKeptCopy = false): Observable<any> {
    const token = localStorage.getItem('token');
    const request = this.http.get(`${this.apiUrl}/appointment-types/group/${groupId}`, { headers: { Authorization: `Bearer ${token}` } });
    const source = fromKeptCopy && this.settingsStore ? this.settingsStore.read(groupId, 'appointmentTypes', () => request) : request;
    return source
      .pipe(
        tap((results: any) => {
          const sorted = Array.isArray(results)
            ? [...results].sort((a, b) => (a.type || '').localeCompare(b.type || '', undefined, { sensitivity: 'base' }))
            : results;
          this.appointmentTypesSubject.next(sorted);
        })
      );
  }

  updateAppointmentTypes(appointmentTypes: any[]): Observable<any> {
    const token = localStorage.getItem('token');
    return this.http.put(`${this.apiUrl}/appointment-types`, { groupId: this.groupId, appointmentTypes }, {
      headers: { Authorization: `Bearer ${token}` }
    }).pipe(
      switchMap(() => this.getAppointmentTypesByGroup(this.groupId!))
    );
  }
}
